/** DDDs brasileiros em uso (Anatel). */
const DDD = new Set([
  11, 12, 13, 14, 15, 16, 17, 18, 19, 21, 22, 24, 27, 28, 31, 32, 33, 34, 35, 37, 38, 41, 42, 43, 44, 45, 46,
  47, 48, 49, 51, 53, 54, 55, 61, 62, 63, 64, 65, 66, 67, 68, 69, 71, 73, 74, 75, 77, 79, 81, 82, 83, 84, 85,
  86, 87, 88, 89, 91, 92, 93, 94, 95, 96, 97, 98, 99,
]);

/**
 * Celular brasileiro em E.164 (`+55` + DDD + 9 dígitos começando com 9), ou null.
 * Aceita máscara, espaços, `+55`/`55` e o 0 de longa distância. Fixo não recebe SMS: é recusado.
 */
export function normalizePhone(input: string): string | null {
  let digits = input.replace(/\D/g, '');
  if (digits.length === 13 && digits.startsWith('55')) digits = digits.slice(2);
  else if (digits.length === 12 && digits.startsWith('0')) digits = digits.slice(1);
  if (digits.length !== 11 || !DDD.has(Number(digits.slice(0, 2))) || digits[2] !== '9') return null;
  return `+55${digits}`;
}

/** `+5511999990000` → `(11) 99999-0000`. */
export function formatPhone(phone: string): string {
  const d = phone.replace(/^\+55/, '');
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
}

/** `+5511999990000` → `(11) •••••-0000` (exibição sem revelar o número inteiro). */
export function maskPhone(phone: string): string {
  const d = phone.replace(/^\+55/, '');
  return `(${d.slice(0, 2)}) •••••-${d.slice(7)}`;
}
